import { LoadingOverlay, Paper, SegmentedControl, Stack } from "@mantine/core";
import { useCallback, useMemo, useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import Permissions from "./Permissions";
import UserLimits from "./UserLimits";
import CommunityManager from "./CommunityManager/CommunityManager";
import Interface from "./Interface";

const AdminPanelRight = ({ profile, setProfile, changingProfile }) => {
  const lang = useLanguage((s) => s.language);
  const [tab, setTab] = useState("permissions");

  const tabs = useMemo(() => {
    return [
      {
        label: lang.administration.right.tabs_title.rights,
        value: "permissions",
      },
      {
        label: lang.administration.right.tabs_title.limits,
        value: "limits",
      },
      {
        label: lang.administration.right.tabs_title.community,
        value: "community",
      },
      {
        label: lang.administration.right.tabs_title.interface,
        value: "interface",
      },
    ];
  }, [
    lang.administration.right.tabs_title.rights,
    lang.administration.right.tabs_title.limits,
    lang.administration.right.tabs_title.community,
    lang.administration.right.tabs_title.interface,
  ]);

  const getComponent = useCallback(() => {
    if (tab === "permissions") {
      return <Permissions profile={profile} setProfile={setProfile} />;
    }
    if (tab === "limits") {
      return <UserLimits profile={profile} setProfile={setProfile} />;
    }
    if (tab === "community") {
      return (
        <CommunityManager
          profile={profile}
          setProfile={setProfile}
          changingProfile={changingProfile}
        />
      );
    }
    if (tab === "interface") {
      return <Interface profile={profile} setProfile={setProfile} />;
    }
  }, [changingProfile, profile, setProfile, tab]);

  return (
    <Paper
      h={"100%"}
      w={"100%"}
      p={"md"}
      py={"xs"}
      component={Stack}
      style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderLeft: "1px solid #00000012" }}
      pos={"relative"}
    >
      <LoadingOverlay visible={changingProfile} />
      <SegmentedControl
        value={tab}
        onChange={setTab}
        size="sm"
        data={tabs}
        radius={"md"}
        styles={{
          label: {
            fontWeight: 600,
          },
        }}
      />
      {getComponent()}
    </Paper>
  );
};

export default AdminPanelRight;
